import except from "./except";
import objGet from "./get";
import merge from "./merge";
import only from "./only";
import set from "./set";
import unset from "./unset";

export { default as only } from "./only";

export default class Obj {
    /**
     * Get the value by the given key
     *
     * @param {any} object
     * @param {string} key
     * @param {any} defaultValue
     * @returns {any}
     */
    public static get(object: any, key: string, defaultValue?: any): any {
        return objGet(object, key, defaultValue);
    }

    /**
     * Deep merge objects
     *
     * @param {any} target
     * @param {any[]} sources
     * @returns {object}
     */
    public static merge(target: object, ...sources: object[]) {
        return merge(target, ...sources);
    }

    /**
     * Set value to the given array
     *
     * @param {object} object
     * @param {string} key
     * @param {any} value
     * @returns {void}
     */
    public static set(object: object, key: string, value: any) {
        return set(object, key, value);
    }

    /**
     * Remove the given keys from the given object
     *
     * @param {object} object
     * @param {string[]} keys
     * @returns {void}
     */
    public static unset(object: object, keys: string[]) {
        return unset(object, keys);
    }

    /**
     * Get all object data except for the given keys
     *
     * @param {any} object
     * @param {string[]} keys
     * @returns {any}
     */
    public static except(object: object, keys: string[]) {
        return except(object, keys);
    }

    /**
     * Get the only given keys from the given object
     *
     * @param {any} object
     * @param {string[]} keys
     * @returns {any}
     */
    public static only(object: object, keys: string[]) {
        return only(object, keys);
    }
}
